import axios from 'axios'

const RESET = 'RESET'

const BASE_URL = 'api/DataSources/Synonyms'
const ADD_SYNONYM_URL = `${BASE_URL}`
const UPDATE_SYNONYM_URL = `${BASE_URL}`

let initialState = () => ({})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async addSynonym(_, {
      synonymName,
      isPrimary,
      sourceType,
      sourceId,
      synonymData,
    }) {
      try {
        let response = await axios.post(ADD_SYNONYM_URL, {
          synonymName,
          isPrimary,
          sourceType,
          sourceId,
          synonymData,
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async updateSynonym(_, {
      synonymId,
      synonymName,
      isPrimary,
      sourceType,
      sourceId,
      synonymData,
    }) {
      try {
        let response = await axios.put(UPDATE_SYNONYM_URL, {
          synonymId,
          synonymName,
          isPrimary,
          sourceType,
          sourceId,
          synonymData,
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
    async removeSynonym(_, {
      synonymName,
      sourceType,
      sourceId,
      assignToLocation,
    }) {
      try {
        let response = await axios.delete(ADD_SYNONYM_URL, {
          data: {
            synonymName,
            sourceType,
            sourceId,
            assignToLocation,
          },
        })

        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
  },
  mutations: {
    [RESET](state) {
      state.configurations = initialState.configurations
    },
  },
}